import { getMuiLineChartTableDataFromChartData } from '../../../../ui-components/data-viz-ui/charts/line-chart/line-chart-utils';
import { TableViewComponentProps } from '../../../../ui-components/data-viz-ui/table/table-view-component-types';
import {
  ComponentStateManager,
  DataVizContainerCommonUtils,
} from '../../../common/types';
import { getLineChartDataFromOverTimeUnsegmentedResponse } from '../../over-time-unsegmented-utils';
import {
  OverTimeUnsegmentedVizData,
  OverTimeUnsegmentedVizExternalProps,
} from '../../types';
import {
  OverTimeUnsegmentedTableViewActions,
  OverTimeUnsegmentedTableViewState,
} from './types';

export const overTimeUnsegmentedTableViewDataToUiComponentProps = (
  data: OverTimeUnsegmentedVizData,
  externalProps: OverTimeUnsegmentedVizExternalProps,
  componentStateManager: ComponentStateManager<
    OverTimeUnsegmentedTableViewState,
    OverTimeUnsegmentedTableViewActions
  >,
  { t }: DataVizContainerCommonUtils
): TableViewComponentProps => {
  const { fullScreenHandle, preferences } = externalProps;
  const { dataResponse, titleConfig, metricDisplayValues, metricDetailsMap } =
    data;
  const chartData = getLineChartDataFromOverTimeUnsegmentedResponse(
    dataResponse,
    metricDisplayValues,
    metricDetailsMap,
    t
  );
  const tableData = getMuiLineChartTableDataFromChartData(
    chartData,
    {
      selectedSortOrder: null,
    },
    t
  );
  const displayConfig = {
    ...componentStateManager.state.displayState,
    ...componentStateManager.actions.displayActions,
  };
  return {
    fullScreenHandle,
    displayConfig,
    titleConfig,
    tableData,
  };
};
